<script lang="ts">
  import { emojis } from "$app/constants"
  import { onMount } from "svelte"
  import { timeAgoOrDate } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  interface Props {
    recognition: RecognitionType
  }

  let { recognition }: Props = $props()

  const current_user = appStore.current_user

  let reaction = null
  let isLiked = false

  let hasEmojiReactions = function (emoji: string) {
    return recognition.reactions.filter((r) => r.emoji === emoji).length > 0
  }

  let reactionsByEmoji = function (emoji: string) {
    return recognition.reactions.filter((r) => r.emoji === emoji)
  }

  onMount(() => {
    if (recognition.reactions.length > 0) {
      let myReaction = recognition.reactions.filter(
        (r) => r.user_id === current_user.id
      )
      if (myReaction.length > 0) {
        isLiked = true
        reaction = myReaction[0]
      }
    }
  })
</script>

<li class="splide__slide">
  <div class="bg-white rounded-lg shadow-lg">
    <div class="grid grid-cols-12 h-156">
      <div class="px-4 py-5 col-span-3 2xl:col-span-2">
        <div class="pr-4 sm:pr-2">
          <div
            class="flex overflow-visible flex-wrap justify-center items-center"
          >
            {#each recognition.recipients as recipient}
              <img
                class="inline-block h-8 w-8 md:h-12 md:w-12 lg:w-20 lg:h-20 rounded-full ring-2 ring-white"
                src={recipient.avatar_thumb_url}
                alt={recipient.name}
              />
            {/each}
          </div>
        </div>
        <p class="mt-6 text-base md:text-lg text-gray-500 text-center">
          {timeAgoOrDate(recognition.created_at, 2)}
        </p>
      </div>
      <div
        class="col-span-9 2xl:col-span-10 py-5 px-8 border-l border-gray-200"
      >
        <p class="text-xl md:text-2xl lg:text-3xl text-gray-800 mb-2 mr-6">
          {#if recognition.sender_name}
            <span class="text-blue-700">
              {recognition.sender_name}
            </span>
          {:else}
            <span class="text-blue-700">
              {recognition.sender_with_fallback}
            </span>
          {/if}
          <span class="italic">recognizes</span>
          <span class="font-bold">{recognition.recipient_fullnames}</span>
        </p>
        <div
          class="mt-6 mr-8 text-gray-700 text-base lg:text-2xl overflow-y-auto ProseMirror border-l-2 border-gray-300 bg-gray-50"
        >
          <div class="py-4 px-6">
            {@html recognition.comment}
          </div>
        </div>
        <div class="flex flex-wrap items-center my-2 mt-6">
          {#if recognition.statements}
            {#each recognition.statements as statement (statement.id)}
              <span
                class="mx-1 my-1 flex items-center px-2 py-1 border rounded border-blue-100 bg-gray-50"
              >
                <img
                  src={statement.symbol_url}
                  class="h-14 mr-3"
                  alt={statement.name}
                />
                <p class="text-base font-bold lg:text-lg">{statement.name}</p>
              </span>
            {/each}
          {/if}
        </div>
      </div>
    </div>

    <div class="border-t border-gray-200 w-full">
      <div
        class="grid grid-cols-2 py-2 px-6 bg-gray-50 border-b border-gray-200"
      >
        <div class="flex justify-start items-center">
          {#key recognition.reactions}
            {#each emojis as emoji}
              {#if hasEmojiReactions(emoji.name)}
                <img
                  src={emoji.url}
                  class="h-8 w-8 lg:h-14 lg:w-14 ml-3"
                  data-name="reaction-icon"
                  alt="Reaction {emoji.name}"
                />
                <div
                  class="flex -space-x-2 overflow-hidden"
                  data-name="reaction-users"
                >
                  {#each reactionsByEmoji(emoji.name) as reaction}
                    <img
                      class="inline-block h-8 w-8 lg:w-12 lg:h-12 rounded-full ring-2 ring-white"
                      src={reaction.avatar_thumb_url ||
                        reaction.user.avatar_thumb_url}
                      alt="reaction"
                    />
                  {/each}
                </div>
              {/if}
            {/each}
          {/key}
        </div>
        <div class="flex items-center justify-end text-sm lg:text-base py-1">
          {#if recognition.comments.length > 1}
            {recognition.comments.length} Comments
          {:else if recognition.comments.length === 1}
            1 Comment
          {:else}
            No Comments
          {/if}
        </div>
      </div>
    </div>
  </div>
</li>
